module.exports = __webpack_public_path__ + "img/hero.50f809d5.jpg";